import React, { useState, useEffect } from "react";
import Footer from "./Components/Footer";
import Loader from "./Components/Loader";
import Navbar from "./Components/Navbar";
import Skills from "./Components/Skills";
import TopIntro from "./Components/TopIntro";
import Works from "./Components/Works";

function App() {
  const [isLoaded, setisLoaded] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setisLoaded(true)
    }, 500);
  }, [])

  if (!isLoaded) {
    return (
      <Loader />
    )
  } else {
    return (
      <>
        <Navbar />
        <TopIntro />
        <Works />
        <Skills />
        <Footer />
      </>
    );
  }
}

// npm run build 
// firebase deploy 
// -to deploy  the app

export default App;
